<template>
  <Modal
    v-model="showModal"
    width="1200"
    @on-cancel="cancel"
    @on-ok="submit"
    :styles="{ top: '100px' }"
  >
    <div class="material-wrap">
      <div class="top">
        <h2>{{ type == "fabric" ? "面料选择" : "辅料选择" }}</h2>
        <div class="input-wrap">
          <input
            v-model="form_data.keyword"
            placeholder="输入关键词进行搜索"
            type="text"
            @keyup.enter="do_search"
          />
          <img
            alt=""
            class="icon-search"
            src="@/assets/images/icon-search.png"
            @click="do_search"
          />
        </div>
      </div>

      <div class="content">
        <div class="left category-list">
          <div
            v-for="(v, k) in category_list"
            :key="`dc` + k"
            :class="{
              active: form_data.fabric_category_id === v.fabric_category_id,
            }"
            class="category-item cursor"
            @click="choose_fabric_category(v)"
            v-if="type == 'fabric'"
          >
            {{ v.category_name }}
          </div>
          <div
            v-for="(v, k) in category_list"
            :key="`dc` + k"
            :class="{
              active:
                form_data.accessory_category_id === v.accessory_category_id,
            }"
            class="category-item cursor"
            @click="choose_accessory_category(v)"
            v-if="type == 'accessory'"
          >
            {{ v.category_name }}
          </div>
        </div>
        <div class="right-content">
          <div class="label-list">
            <div class="label-item">
              <p>发布：</p>
            </div>
            <div
              v-for="(vv, kk) in publish_time_list"
              :key="`lf2` + kk"
              :class="{ active: publish_time_selected.includes(vv.value) }"
              class="label-item"
              @click="choose_publish_time(vv)"
            >
              <p>{{ vv.name }}</p>
            </div>
          </div>
          <div v-for="(v, k) in label_list" :key="`lf1` + k" class="label-list">
            <div class="label-item">
              <p>{{ v.label_name }}：</p>
            </div>
            <div
              v-for="(vv, kk) in v.content"
              :key="`lf2` + kk"
              :class="{ active: label_ids.includes(vv.id) }"
              class="label-item"
              @click="choose_label(vv)"
            >
              <p>{{ vv.name }}</p>
            </div>
          </div>

          <template v-if="list.length > 0">
            <div class="fabric-list">
              <div
                v-for="(v, k) in list"
                :key="`df` + k"
                :class="{ active: v.checked }"
                class="fabric-item"
                @click="selectItem(v)"
              >
                <div class="img-box-with-hover">
                  <img :src="v.image | default_img" alt="" />
                </div>
                <p class="name">
                  {{ type == "fabric" ? v.fabric_name_cn : v.accessory_name }}
                </p>
                <p class="code" v-if="type == 'fabric'">
                  面料编码：{{ v.fabric_key }}
                </p>
                <p class="code" v-if="type == 'accessory'">
                  辅料编码：{{ v.accessory_sku }}
                </p>
                <img
                  v-show="v.checked"
                  alt=""
                  class="icon-check"
                  src="@/assets/images/icon-check.png"
                />
              </div>
            </div>
            <Page
              :current="form_data.page"
              v-if="total > 0"
              :page-size="form_data.size"
              :total="total"
              @on-change="changePage"
              show-total
              style="margin-top: 20px"
            ></Page>
          </template>
          <template v-else>
            <img
              class="no-data"
              :src="require(`@/assets/images/no-data.png`)"
              alt=""
            />
          </template>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import {
  FabricList,
  AccessoryList,
  FabricLabelList,
  AccessoryLabelList,
  AccessoryCategoryList,
  FabricCategoryList,
} from "@/api/index.js";

export default {
  name: "SelectFabricAccessory",
  props: {},
  data() {
    return {
      total: 0,
      showModal: false,
      list: [],
      type: "fabric",
      form_data: {
        page: 1,
        size: 12,
        keyword: "",
        accessory_category_id: 0,
        fabric_category_id: 0,
      },
      category_list: [],
      publish_time_list: [
        { name: "3个月", value: "3" },
        { name: "6个月", value: "6" },
        { name: "9个月", value: "9" },
        { name: "1年", value: "12" },
        { name: "1年以上", value: "12+" },
      ],
      publish_time_selected: [],
      label_list: [],
      label_ids: [],
      selected_ids: [],
    };
  },
  watch: {},
  methods: {
    show(type) {
      this.type = type;
      this.getLabelList();
      this.getCategoryList();
      this.getList();
      this.showModal = true;
    },
    do_search() {
      this.form_data.page = 1;
      this.getList();
    },
    changePage(page) {
      this.form_data.page = page;
      this.getList();
    },
    choose_accessory_category(category) {
      this.form_data.accessory_category_id = category.accessory_category_id;
      this.form_data.page = 1;
      this.getList();
    },
    choose_fabric_category(category) {
      this.form_data.fabric_category_id = category.fabric_category_id;
      this.form_data.page = 1;
      this.getList();
    },
    choose_publish_time(data) {
      if (this.publish_time_selected.includes(data.value)) {
        this.publish_time_selected = this.publish_time_selected.filter(
          (item) => {
            return item !== data.value;
          }
        );
      } else {
        this.publish_time_selected.push(data.value);
      }
      this.getList();
    },
    choose_label(v) {
      if (this.label_ids.includes(v.id)) {
        this.label_ids = this.label_ids.filter((item) => {
          return item !== v.id;
        });
      } else {
        this.label_ids.push(v.id);
        this.label_ids = [...new Set(this.label_ids)];
      }
      this.form_data.page = 1;
      this.getList();
    },
    selectItem(v) {
      this.$set(v, "checked", !v.checked);
    },
    async getLabelList() {
      if (this.type == "fabric") {
        FabricLabelList().then((response) => {
          this.label_list = [...response.data];
        });
      } else {
        AccessoryLabelList().then((response) => {
          this.label_list = [...response.data];
        });
      }
    },
    async getCategoryList() {
      if (this.type == "fabric") {
        FabricCategoryList().then((response) => {
          this.category_list = [
            { category_name: "全部", fabric_category_id: 0 },
            ...response.data,
          ];
        });
      } else {
        AccessoryCategoryList().then((response) => {
          this.category_list = [
            { category_name: "全部", accessory_category_id: 0 },
            ...response.data,
          ];
        });
      }
    },
    oc(v) {
      return [v.status_text];
    },
    selectOn(v) {
      this.$set(v, "checked", !v.checked);
    },
    async getList() {
      this.list = [];
      if (this.type == "fabric") {
        const param = {
          ...this.form_data,
          label_id: this.label_ids,
        };
        if (this.publish_time_selected.length > 0) {
          param.publish_range = this.publish_time_selected;
        }
        return FabricList(param).then((response) => {
          this.list = response.data.list;
          this.total = response.data.total;
        });
      } else {
        const param = {
          ...this.form_data,
          label_id: this.label_ids,
        };
        if (this.publish_time_selected.length > 0) {
          param.publish_range = this.publish_time_selected;
        }
        AccessoryList(param).then((response) => {
          this.list = response.data.list;
          this.total = response.data.total;
        });
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    submit() {
      let list = this.list.filter((i) => {
        return i.checked;
      });
      this.$emit("select-fabric", {
        list,
        type:this.type
      });
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.material-wrap {
  margin-top: 10px;
  margin-right: 50px;
  padding: 10px;
  background: white;
  width: 100%;

  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 5px;
    border-bottom: 2px solid #f6f7fa;
    h2 {
      font-size: 20px;
      color: #1a1a1a;
      white-space: nowrap;
    }

    .input-wrap {
      margin-left: 50px;
      width: 280px;
      height: 35px;
      position: relative;

      &:focus {
        border: none !important;
      }

      &::after {
        border: none !important;
      }

      input {
        width: 100%;
        height: 100%;
        background: #f2f2f2;
        border-radius: 17px;
        padding: 0 45px 0 20px;
        border: none !important;

        &:focus {
          border: none !important;
        }

        &::after {
          border: none !important;
        }
      }

      .icon-search {
        position: absolute;
        right: 18px;
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }
  }

  /* 主内容区 */
  .content {
    display: flex;

    /* 左侧分类 */
    .category-list {
      width: 100px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: flex-start;
      border-right: 1px solid #f6f7fa;
      overflow-y: auto;
      padding: 15px 0;
      max-height: 500px;

      .category-item {
        width: 80px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #1c1c1c;
        border-radius: 5px;
        &.active {
          background: #1c1c1c;
          color: white;
          font-weight: 500;
        }
      }
    }

    /* 右侧内容 */
    .right-content {
      $left_width: 140px;
      width: calc(100% - #{$left_width});
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 10px;
      overflow: hidden;

      /* 标签筛选区 */
      .label-list {
        display: flex;
        flex-wrap: wrap;
        gap: 12px 0;
        margin-bottom: 5px;

        .label-item {
          padding: 0 15px;
          height: 20px;
          line-height: 20px;
          border-radius: 15px;
          //   background: #f6f6f6;
          cursor: pointer;
          transition: all 0.2s;

          &.active {
            background: #ffecee;
            color: #fa3d5a;
            font-weight: 500;
          }
        }
      }

      /* 子分类 */
      .sub-list {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 10px;
        margin-bottom: 10px;
        background: #f6f6f6;

        .sub-item {
          padding: 0 12px;
          height: 28px;
          line-height: 28px;
          border-radius: 14px;
          cursor: pointer;
          transition: all 0.2s;

          &.active {
            background: #fa3d5a;
            color: white;
          }
        }
      }

      .no-data {
        width: 300px;
        height: auto;
        display: block;
        margin: 0 auto;
      }
      /* 辅料列表 */
      .fabric-list {
        flex: 1;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
        border-radius: 5px;
        column-gap: 10px;
        row-gap: 10px;
        align-items: start;
        overflow-y: auto;
        padding: 15px;
        background: #f6f7fa;
        width: 100%;
        max-height: 650px;

        &::-webkit-scrollbar {
          display: none !important;
        }

        .fabric-item {
          position: relative;
          height: 200px;
          cursor: pointer;
          box-sizing: border-box;
          background-color: #fff;
          padding: 8px;

          .img-box-with-hover {
            width: 144px;
            height: 144px;
            position: relative;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .name {
            width: 100%;
            line-height: 30px;
            font-size: 14px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            text-align: left;
            color: #000000;
          }
          .code {
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            line-height: 12px;
            text-align: left;
            // margin-top: 5px;
          }

          .icon-check {
            position: absolute;
            top: 0;
            right: 0;
            width: 25px;
            height: 25px;
          }

          &.active {
            border: 1px solid #fa3d5a;
          }

          .mask {
            display: none;
          }

          &:hover {
            .mask {
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              height: 140px;
              z-index: 100;
              background: rgba(0, 0, 0, 0.35);
              .mask-btn-box {
                display: flex;
                justify-content: space-between;
                align-items: end;
                width: 100%;
                height: 100%;
                padding: 0 10px;
                .fa-detail {
                  color: white;
                  font-weight: bold;
                }

                .fa-choose {
                  color: white;
                  font-weight: bold;
                }
              }
            }
          }
        }
      }

      /* 底部按钮 */
      .btn-group {
        display: flex;
        justify-content: flex-end;
        gap: 15px;
        padding-top: 10px;

        .btn {
          min-width: 100px;
          height: 38px;
          line-height: 38px;
          border-radius: 5px;
          cursor: pointer;
          transition: all 0.2s;
          text-align: center;

          &.btn-cancel {
            color: black;
            border: 1px solid #e5e5e5;
          }

          &.btn-confirm {
            color: white;
            background: #fa3d5a;
          }
        }
      }
    }
  }

  .color-mask {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 200;
    .color-wrap {
      position: absolute;
      width: 600px;
      height: 300px;
      top: calc(50% - 150px);
      left: calc(50% - 300px);
      background: white;
      border-radius: 10px;
      z-index: 10000;
      padding: 20px 10px 0 10px;

      .title {
        font-size: 16px;
        font-weight: bold;
        color: #1a1a1a;
      }

      .color-list {
        display: flex;
        flex-wrap: wrap;
        width: 560px;
        height: 100%;
        min-height: 150px;
        max-height: 170px;
        overflow-y: auto;
        row-gap: 10px;

        .color-item {
          width: 120px;
          height: 46px;
          border: 1px solid #e5e5e5;
          border-radius: 5px 5px 5px 5px;
          margin: 0 8px;
          display: flex;
          align-items: center;
          padding: 0 5px;
          cursor: pointer;

          img {
            width: 30px;
            height: 30px;
            margin-right: 5px;
          }

          &.active {
            border-color: #fa3d5a;

            span {
              color: #fa3d5a;
            }
          }
        }
      }

      .btn-group {
        margin-top: 24px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        border-top: 1px solid #e5e5e5;
        height: 58px;

        .btn {
          width: 100px;
          height: 38px;
          line-height: 38px;
          border-radius: 5px;
          text-align: center;
          font-size: 14px;
          margin: 0 7px;
          cursor: pointer;

          &.btn-cancel {
            color: black;
            border: 1px solid #e5e5e5;
          }

          &.btn-confirm {
            color: white;
            background: #fa3d5a;
          }
        }
      }
    }
  }
}
</style>
